import type { FaireProductEntity } from "../../entity_types/product";

export const p_8gny2cq9wd: FaireProductEntity = {
  token: "p_8gny2cq9wd",
  type: "product",
  name: "Vintage Three Kyanite Natural Stone Adjustable Ring - CS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/35fa133afac72d4d02c89997243c62ce65ec950ccbf63bdcd2573b06266c3f6b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/572847aad73a13566ea46344e616a019c44f612a3e24eb87843cd659d5093121.jpeg",
    "https://cdn.faire.com/fastly/226d12f4d03b6be45f1f199a48c7c1a39e330e5057717a5930f6d90387a6acd5.jpeg",
    "https://cdn.faire.com/fastly/02c9b9b88d12dff580acc70efacd67e007d8787581a60c618e19aab60ccecb16.jpeg",
  ],
  priceDollars: 10.4,
  description:
    "Kind reminder: Stones and crystals are made of natural raw stones, and some stones have cracks, which is a normal phenomenon\n\nType: Ring\n\nMaterial : Stone\nSize : 7#~8# ，adjustable\n\n★Made of high quality material, Nickel-free / Lead-free, Harmless to Human Body.\n\n★Perfect jewelry gifts\n\n",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:55.292Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
